const {
  select,
  find,
  toggleClass,
  parent,
  next,
  addClass,
  removeClass,
} = DOM;

const CatalogFilter = {
  filter: null,
  bindToggle() {
    const toggle = find(this.filter, '[data-action="catalog.filter.toggle"]');

    if (toggle) {
      toggle.addEventListener('click', () => {
        toggleClass(this.filter, 'is_show');
      });
    }
  },

  bindSearch() {
    const search = find(this.filter, '[data-selector="search.input"]');
    const searchButton = find(this.filter, '[data-selector="search.button"]');
    const noResult = find(this.filter, '[data-action="catalog.filter.empty"]');
    const result = Array.from(next(parent(search)).children);

    searchButton?.addEventListener('click', () => {
      search.value = '';
      result.forEach(item => {
        removeClass(item, 'is_hide');
      });
    });

    search?.addEventListener('input', (e) => {
      const value = e.target.value.trim().toLowerCase();
      let found = false;
      result.forEach(item => {
        const text = item.dataset.item.toLowerCase();
        if (text.includes(value)) {
          removeClass(item, 'is_hide');
          found = true
        } else {
          addClass(item, 'is_hide');
        }
      });
      noResult.style.display = found ? 'none' : 'block';
    });
  },
  bindHead() {
    const head = find(this.filter, '[data-action="catalog.filter.head"]');
    const body = find(this.filter, '[data-action="catalog.filter.body"]');

    if (head && body) {
      head.addEventListener('click', () => {
        toggleClass(head, 'is_show');
        toggleClass(body, 'is_show');
      });
    }
  },
  init() {
    const filter = select('[data-selector="catalog.filter"]');

    if (filter) {
      this.filter = filter;
      this.bindHead();
      this.bindSearch();
      this.bindToggle();
    }
  }
}

export default CatalogFilter;